__webpack_require__.p = "https://cdn.healthcare.com/healthcare.com-static/qa/2026-04-28--gntc-36-qa-1/_next/";